
import React, { useState, useEffect } from 'react';
import { Download, X, Smartphone, Zap, ShieldCheck } from 'lucide-react';

const InstallBanner: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: any) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
      // Show the custom banner after a small delay
      setTimeout(() => setIsVisible(true), 3000);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsVisible(false);
    }

    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    
    // Show the native install prompt
    deferredPrompt.prompt();
    
    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response to the install prompt: ${outcome}`);
    
    // We've used the prompt, and can't use it again, throw it away
    setDeferredPrompt(null);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed top-24 left-1/2 -translate-x-1/2 z-[110] w-[90%] max-w-lg animate-fade-in-up">
      <div className="relative group">
        {/* Glow Background */}
        <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 to-magenta-500 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
        
        <div className="relative bg-slate-900/90 backdrop-blur-2xl border border-white/10 p-5 rounded-2xl flex items-center justify-between gap-6 shadow-2xl">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-cyan-500/10 rounded-xl flex items-center justify-center text-cyan-400 shrink-0">
              <Smartphone size={24} className="animate-pulse" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h4 className="text-white text-[11px] font-black uppercase tracking-widest">Native Deployment</h4>
                <div className="px-1.5 py-0.5 bg-green-500/10 text-green-500 text-[8px] font-black rounded border border-green-500/20">READY</div>
              </div>
              <p className="text-slate-400 text-[10px] font-medium leading-relaxed">
                Install <span className="text-white">M.Taibe Terminal</span> for premium offline access & faster sync.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button 
              onClick={handleInstallClick}
              className="bg-cyan-600 hover:bg-cyan-500 text-slate-950 px-4 py-2 rounded-xl text-[9px] font-black uppercase tracking-widest transition-all shadow-lg shadow-cyan-500/20 active:scale-95 whitespace-nowrap"
            >
              Deploy App
            </button>
            <button 
              onClick={() => setIsVisible(false)}
              className="p-2 text-slate-500 hover:text-white transition-colors"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstallBanner;
